export const getDistributionButtonStyle = (condition: boolean) => {
  let disabled;
  let background;
  let pointer;

  if (condition) {
    disabled = true;
    background = 'tw-bg-[#828282]';
    pointer = 'tw-cursor-not-allowed';
  } else {
    disabled = false;
    background = 'tw-bg-[#FF5000]';
    pointer = 'tw-cursor-pointer';
  }

  const result = {
    disabled,
    background,
    pointer
  };

  return result;
};
